function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCalling = function SvgCalling(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    style: {
      enableBackground: "new 0 0 25.625 25.625"
    },
    viewBox: "0 0 25.625 25.625",
    y: "0px",
    x: "0px",
    id: "Capa_1",
    ref: svgRef
  }, props), React.createElement("title", null, title), React.createElement("g", {
    id: "g3756"
  }, React.createElement("path", {
    id: "path3754",
    d: "M22.079,17.835c-1.548-1.324-3.119-2.126-4.648-0.804l-0.913,0.799   c-0.668,0.58-1.91,3.29-6.712-2.234C5.005,10.079,7.862,9.22,8.531,8.645l0.918-0.8c1.521-1.325,0.947-2.993-0.15-4.71l-0.662-1.04   C7.535,0.382,6.335-0.743,4.81,0.58L3.986,1.3C3.312,1.791,1.428,3.387,0.971,6.419c-0.55,3.638,1.185,7.804,5.16,12.375   c3.97,4.573,7.857,6.87,11.539,6.83c3.06-0.033,4.908-1.675,5.486-2.272l0.827-0.721c1.521-1.322,0.576-2.668-0.973-3.995   L22.079,17.835z",
    style: {
      fill: "#fff"
    }
  })), React.createElement("g", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    },
    id: "g3866",
    transform: "matrix(0.04840915,0,0,0.04840954,0.58656258,0.25300118)"
  }, React.createElement("g", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    },
    id: "g3864"
  }, React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    },
    id: "path3862",
    d: "M 388.818,123.184 C 359.609,93.975 320.776,77.89 279.474,77.891 c -8.481,0 -15.356,6.875 -15.356,15.356 0,8.481 6.876,15.356 15.356,15.356 33.1,-0.002 64.219,12.89 87.628,36.297 23.406,23.406 36.295,54.525 36.294,87.624 0,8.481 6.875,15.358 15.356,15.358 8.48,0 15.356,-6.875 15.356,-15.354 10e-4,-41.304 -16.085,-80.135 -45.29,-109.344 z"
  }))), React.createElement("g", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    },
    id: "g3872",
    transform: "matrix(0.04840915,0,0,0.04840954,0.58656258,0.25300118)"
  }, React.createElement("g", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    },
    id: "g3870"
  }, React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    },
    id: "path3868",
    d: "M 443.895,68.107 C 399.972,24.186 341.578,-0.002 279.468,0 c -8.481,0 -15.356,6.876 -15.356,15.356 0,8.481 6.876,15.356 15.356,15.356 53.907,-0.002 104.588,20.992 142.709,59.111 38.118,38.118 59.111,88.799 59.11,142.706 0,8.481 6.875,15.356 15.356,15.356 8.48,0 15.356,-6.875 15.356,-15.354 0.002,-62.112 -24.186,-120.504 -68.104,-164.424 z"
  }))), React.createElement("g", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    },
    id: "g3878",
    transform: "matrix(0.04840915,0,0,0.04840954,0.58656258,0.25300118)"
  }, React.createElement("g", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    },
    id: "g3876"
  }, React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    },
    id: "path3874",
    d: "m 333.737,178.26 c -14.706,-14.706 -33.465,-22.477 -54.256,-22.477 0,0 -0.005,0 -0.006,0 -8.481,0.002 -15.356,6.876 -15.354,15.358 0.002,8.481 6.878,15.356 15.358,15.354 0.002,0 0.003,0 0.005,0 12.644,0 23.593,4.536 32.539,13.481 8.819,8.82 13.481,20.075 13.479,32.544 -0.002,8.481 6.875,15.356 15.354,15.358 h 0.002 c 8.481,0 15.354,-6.875 15.356,-15.354 10e-4,-20.792 -7.77,-39.556 -22.477,-54.264 z"
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCalling, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calling.c5c83aa9.svg";
export { ForwardRef as ReactComponent };